import { BaseComponentProps } from "../core/components/baseComponentProps";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { EditSignatureContext} from "./editSignature";
import React from "react";
export default class SQLGeneratorButton extends React.Component<SQLGeneratorButtonProps, SQLGeneratorButtonState>{
    constructor(props) {
        super(props)
        this.state = {
            onHover: false
        }
    }

    private onClick = async () => {
        const sql = `SELECT
   SIGNEDBY, -- Name of the signatory (e.g. Jon Doe)
   SIGNATUREIMAGE, -- Data-Uri base64 encoded svg image of signature (embed using QuickReport component "Signature")
   REASON, -- Assigned "reason" in print language
   DATEFORMAT, -- Date format if overridden at the end of the signature section below the signature definition records.
   UTCDATETIMESTAMP, -- Signature creation timestamp in UTC
   UTCOFFSET -- UTC offset in minutes: Deviation from UTCDATETIMESTAMP to the local time of signature entry.
    
FROM PRINTSERVICESIGNATURES
WHERE JOBID = :PPrintJobId
AND UNIQUENAME = '${this.props.value.replace("'", "''")}'`

        await navigator.clipboard.writeText(sql);
        NotificationHelper.showSuccessMessage(this.props.context.translations["WebSMS.ReportMetadata.SavedToClipboard"])
    }

    render() {
        if (Helper.isNullOrEmpty(this.props.value) || !Helper.hasValue(navigator) || !Helper.hasValue(navigator.clipboard)) {
            return null;
        } else {
            const style: React.CSSProperties = {
                width: "100%",
                height: "35px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                border: "1.75px solid var(--secondary-color)",
                backgroundColor: `var(${this.state.onHover ? "--secondary-color" : " --primary-color"})`,
                color: "white"
            };
            return (
                <div
                    style={style}
                    onMouseOver={() => { this.setState({ onHover: true }) }}
                    onMouseLeave={() => { this.setState({ onHover: false }) }}
                    onClick={this.onClick}
                >
                    <i className="fal fa-clipboard fa-2x" style={{ marginRight: "5px" }}></i>
                    <label style={{ cursor: "pointer" }}>
                        {this.props.context.translations["WebSMS.ReportMetadata.SQLToClipboard"]}
                    </label>
                </div>
            );
        }
    }
}

interface SQLGeneratorButtonProps extends BaseComponentProps {
    context: EditSignatureContext;
    value: string;
}

interface SQLGeneratorButtonState {
    onHover: boolean;
}